import OrderFinishedCargoOrdersCountRequest, {
  OrderFinishedCargoOrdersCountQueryParams,
} from "./order-finished-cargo-orders-count.request";

const createQueryParams = (
  request: OrderFinishedCargoOrdersCountRequest,
): OrderFinishedCargoOrdersCountQueryParams => {
  return {
    address: request.address,
    client: request.client,
    dispatch: request.dispatch,
    driver: request.driver,
    endAddress: request.endAddress,
    externalId: request.externalId,
    humanId: request.humanId,
    isApproved: request.isApproved,
    isCancelled: request.isCancelled,
    midAddress: request.midAddress,
    order: request.order,
    passenger: request.passenger,
    publicStatus: request.publicStatus,
    startAddress: request.startAddress,
    startTimeSince: request.startTimeSince,
    startTimeTo: request.startTimeTo,
    taxi: request.taxi,
  };
};

const orderFinishedCargoOrdersCountRequestFactory = {
  createQueryParams,
};

export default orderFinishedCargoOrdersCountRequestFactory;
